import React from 'react';
import img1 from './assets/Kirtans.webp';
import img3 from './assets/Maha Abhishekam.webp';
import img2 from './assets/Maha Aarti.webp';
import img4 from './assets/Pravachanam.webp';
import img5 from './assets/Annadanam.webp';


import styles from './JCarousel.module.css';

const cards = [
  {
    img: img1,
    title: "Kirtans ",
    text: "Behold Lord Sri Radha Shyamsundar in His most exquisite and opulent form on this sacred day.",
    alt: ""
  },
  {
    img: img3,
    title: "Maha Abhishekam",
    text: " Engage your soul in the uplifting waves of kirtans and bhajans led by senior Vaishnavas.",
    alt: "Shankabhishekam Image"
  },
  {
    img: img2,
    title: "Maha Aarti",
    text: "Witness the ceremonial bathing of the Lord with sanctified conch water during the auspicious Maha Shankhabhishekam.",
    alt: "Shankabhishekam Image"
  },
  {
    img: img4,
    title: "Pravachanam ",
    text: "Gain deep spiritual insights from renowned preachers narrating Krishna's pastimes.",
    alt: "Pushpabhishekam Image"
  },
  {
    img: img5,
    title: "Anna Danam",
    text: "Experience a breathtaking offering of fragrant flowers showered upon the Lord.",
    alt: "Kirtans Image"
  },
];

const JCarousel = () => {
  return (
    <div className={styles.carouselContainer}>
      <div className={styles.carouselTrack}>
        {[...cards, ...cards].map((card, i) => (
          <div key={i} className={styles.card}>
            <img src={card.img} alt={card.alt} />
            <h3>{card.title}</h3>
            {/* <p>{card.text}</p> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default JCarousel;
